import SDK from './core';

export const getChatMessages = params => SDK.getChatMessages(params);
export const getMessageFromSDK = (msgId, jid) => SDK.getMessageById(msgId, jid);
export const getMediaMessages = params => SDK.getMediaMessages(params);
export const getRecentChatsByPagination = params => SDK.getRecentChatsByPagination(params);
export const getFavouriteMessages = () => SDK.getAllFavouriteMessages();
export const favouriteMessage = (jid, msgIds, status) => SDK.updateFavouriteStatus(jid, msgIds, status);

export const sendTextMessage = params => SDK.sendTextMessage(params);
export const sendMediaFileMessage = (params, startCallback, successCallback, failureCallback) =>
   SDK.sendMediaFileMessage(params, startCallback, successCallback, failureCallback);
export const editTextMessage = params => SDK.editTextMessage(params);
export const editMediaCaption = params => SDK.editMediaCaption(params);
export const sendSeenStatus = (jid, msgId, groupId) => SDK.sendSeenStatus(jid, msgId, groupId);
export const sdkForwardMessagesToMultipleUsers = (toJids, msgIds, isAsync = true, newMsgIds = [], newMediaGroupIds = []) =>
   SDK.forwardMessagesToMultipleUsers(toJids, msgIds, isAsync, newMsgIds, newMediaGroupIds);
export const deleteMessagesForEveryone = (jid, messageIds) => SDK.deleteMessagesForEveryone(jid, messageIds);
export const deleteMessagesForMe = (jid, messageIds) => SDK.deleteMessagesForMe(jid, messageIds);

export const downloadMedia = (messageId, startCallback, successCallback, failureCallback) =>
   SDK.downloadMedia(messageId, startCallback, successCallback, failureCallback);
export const resumeMediaUpload = (messageId, startCallback, successCallback, failureCallback) =>
   SDK.resumeMediaUpload(messageId, startCallback, successCallback, failureCallback);
export const cancelMediaUpload = messageId => SDK.cancelMediaUpload(messageId);
export const cancelMediaDownload = messageId => SDK.cancelMediaDownload(messageId);

export const sendTypingStatus = jid => SDK.sendTypingStatus(jid);
export const sendTypingGoneStatus = jid => SDK.sendTypingGoneStatus(jid);

export const muteChat = (toJid, isMuted) => SDK.updateMuteNotification([toJid], isMuted);
export const clearChat = (jid, flag, msgId) => SDK.clearChat(jid, flag, msgId);
export const deleteChat = jid => SDK.deleteChat(jid);

export const archiveChat = (jid, isArchived) => SDK.updateArchiveChat(jid, isArchived);
